import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaFax, FaMapMarkerAlt } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="footer__inner">
          {/* Column 1: Firm Info */}
          <div className="footer__col">
            <h3 className="footer__brand">Janssen Law</h3>
            <p className="footer__tagline">
              No-nonsense, results-oriented legal counsel serving Toronto and beyond.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer__col">
            <h4 className="footer__heading">Quick Links</h4>
            <ul className="footer__links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/team">Our Team</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Column 3: Practice Areas */}
          <div className="footer__col">
            <h4 className="footer__heading">Practice Areas</h4>
            <ul className="footer__links">
              <li><Link to="/practice-areas/business-law">Business Law</Link></li>
              <li><Link to="/practice-areas/real-estate">Real Estate Law</Link></li>
              <li><Link to="/practice-areas/immigration">Immigration Law</Link></li>
              <li><Link to="/practice-areas/wills-estates">Wills & Estates</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div className="footer__col">
            <h4 className="footer__heading">Contact</h4>
            <ul className="footer__contact">
              <li>
                <FaMapMarkerAlt />
                <span>89 Scollard Street<br />Toronto, Canada M5R 1G4</span>
              </li>
              <li>
                <FaPhone />
                <a href="tel:+14169291103">(416) 929-1103</a>
              </li>
              <li>
                <FaFax />
                <span>(416) 929-9610</span>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:enquiry@janssen-law.com">enquiry@janssen-law.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p>&copy; {currentYear} Janssen Law Professional Corporation. All rights reserved.</p>
          <div className="footer__legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
